import styled from 'styled-components';

export const SectionTitle = styled.h3`
    text-align: left;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 20px;
    color: ${({ theme }) => theme.colors.secondary};
`;
